import { Check, Favorite, Help, Lightbulb, LiveHelp, LocalOffer, ShoppingCart, ThumbsUpDown, TrendingUp, Wallet } from "@mui/icons-material";
import { Box } from "@mui/material";
import ContentNormal from "components/elements/ContentNormal";
import Headline5 from "components/elements/Headline5";
import SectionWrapper from "components/layouts/SectionWrapper";
import { AppContext } from "contexts/AppContext";
import { replaceBrandDataPlaceholders } from "modules/home/util";
import { useContext, useState } from "react"
import { Link } from "react-router-dom";
import { callAPI } from "utils/API";

const FooterSections = (props) => {
    const { brandData, styleGuide } = useContext(AppContext)
    const [sections, setSections] = useState([])

    const sectionBackgroundColor = brandData?.features?.footerSectionsBackgroundColor || styleGuide.color3

    const fetchSections = async () => {
        const sections = await callAPI("/footerSections", "GET");
        if (sections && sections.length > 0) {
            setSections(sections)
        }
    }

    useState(() => {
        fetchSections()
    }, [])

    const amountToDisplay = 4
    const sectionsToDisplay = sections.filter(s => s.placement === props.placement).slice(0, amountToDisplay)

    return (
        <SectionWrapper backgroundColor={sectionBackgroundColor}>
            <Box display={'flex'} flexDirection={{xs: 'column', md: 'row'}} columnGap={{xs: 4, md: 8, lg: 12, xl: 16}} rowGap={8} paddingY={10} justifyContent={'space-between'}>
                <Box flex={1}>
                    { sectionsToDisplay.length > 0 && <FooterSection section={sectionsToDisplay[0]} /> }
                </Box>
                <Box flex={1}>
                    { sectionsToDisplay.length > 1 && <FooterSection section={sectionsToDisplay[1]} /> }
                </Box>
                <Box flex={1}>
                    { sectionsToDisplay.length > 2 && <FooterSection section={sectionsToDisplay[2]} /> }
                </Box>
                <Box flex={1}>
                    { sectionsToDisplay.length > 3 && <FooterSection section={sectionsToDisplay[3]} /> }
                </Box>
            </Box>
        </SectionWrapper>
    )
}

const FooterSection = (props) => {
    const { brandData, styleGuide } = useContext(AppContext)
    const sectionTextColor = brandData?.features?.footerSectionsTextColor || styleGuide.color7

    const getIcon = (icon) => {
        switch (icon) {
            case 'Check':
                return <Check />
            case 'Faq':
                return <LiveHelp />
            case 'Heart':
                return <Favorite />
            case 'Lightbulb':
                return <Lightbulb />
            case 'PriceTag':
                return <LocalOffer />
            case 'QuestionMark':
                return <Help />
            case 'ShoppingCart':
                return <ShoppingCart />
            case 'ThumbsUpDown':
                return <ThumbsUpDown />
            case 'TrendingUp':
                return <TrendingUp />
            case 'Wallet':
                return <Wallet />
            default:
                return <Lightbulb/>
        }
    }

    return (
        <Box display={'flex'} flexDirection={'column'} gap={2} color={sectionTextColor}>
            {getIcon(props.section.icon)}
            <Headline5 style={{ color: sectionTextColor }}>
                {replaceBrandDataPlaceholders(brandData, props.section.title)}
            </Headline5>
            <ContentNormal style={{ color: sectionTextColor }}>
                {replaceBrandDataPlaceholders(brandData, props.section.bodyText)}
            </ContentNormal>

            <ContentNormal>
                <Link to={props.section.buttonLink} style={{ color: sectionTextColor }}>
                    {props.section.buttonText}
                </Link>
            </ContentNormal>
        </Box>
    )
}

export default FooterSections